// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__2wyBj","imgHolder":"login_imgHolder__ieLfD","consent":"login_consent__1aPkU"};